import LoginTab from './LoginTab';
export default LoginTab;
